import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-guide_del",
  "use": "icon-guide_del-usage",
  "viewBox": "0 0 15 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 14\" id=\"icon-guide_del\"><defs><style>#icon-guide_del .a{fill:#1890ff;}</style></defs><path class=\"a\" d=\"M13,14H2V4H3.1v9h8.8V4H13V14Zm-3-3V5h1v6ZM7,11V5H8v6ZM4,11V5H5v6ZM0,3V2H15V3ZM4,1V0h7V1Z\" transform=\"translate(0 0)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol